import { cn } from "@/utils/cn";
import { memo } from "react";

interface CheckFatIconProps {
  className?: string;
}

export const CheckFatIcon = memo(function CheckFatIcon({
  className,
}: CheckFatIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      className={cn("w-6 h-6 fill-black", className)}
    >
      <path d="M33.2606 9.3297L29.9794 6.10861C29.5693 5.69994 29.014 5.47046 28.4351 5.47046C27.8562 5.47046 27.3009 5.69994 26.8909 6.10861L14.2184 18.6252L9.20221 13.758C8.79134 13.3507 8.23582 13.1227 7.65724 13.124C7.07867 13.1253 6.52416 13.3557 6.1151 13.7649L2.83385 17.0461C2.42434 17.4562 2.19434 18.0121 2.19434 18.5917C2.19434 19.1713 2.42434 19.7272 2.83385 20.1373L12.6256 29.9811C12.8288 30.1842 13.07 30.3454 13.3354 30.4554C13.6008 30.5654 13.8853 30.622 14.1726 30.622C14.4599 30.622 14.7444 30.5654 15.0099 30.4554C15.2753 30.3454 15.5165 30.1842 15.7196 29.9811L33.2674 12.4291C33.471 12.2254 33.6323 11.9836 33.7422 11.7174C33.8521 11.4512 33.9083 11.166 33.9076 10.878C33.907 10.59 33.8495 10.305 33.7385 10.0393C33.6275 9.77364 33.4651 9.53249 33.2606 9.3297ZM14.1665 28.4375L4.37467 18.5938L7.65592 15.3125C7.6599 15.3158 7.66357 15.3195 7.66686 15.3235L13.4569 20.9412C13.6613 21.1412 13.9359 21.2532 14.2218 21.2532C14.5078 21.2532 14.7824 21.1412 14.9868 20.9412L28.4454 7.65627L31.7184 10.8828L14.1665 28.4375Z" />
    </svg>
  );
});
